/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.

/*
 * EXPORTS
 */
export default gql`
  query SenderIdReadQuery($senderIdDirectoryId: ID!, $take: PositiveInt!, $skip: Int!) {
    SenderIdRead(senderIdDirectoryId: $senderIdDirectoryId, take: $take, skip: $skip) {
      id,
      senderId,
      message,
      status,
      _totalCount,
      SenderIdDirectory {
        id,
        displayName
      }
    }
  }
`
